<template>
  <div>
    <router-view name="dialog" :contentType="'episodes'"/>
    <transition name="fade">
      <router-view />
    </transition>
  </div>
</template>

<script>
export default {
  beforeDestroy() {
    this.$store.dispatch('destroyCurrentEpisode');
  },
};
</script>

<style lang="scss" scoped>
</style>
